<template>
  <div class="modal-confirm">

    <p class="modal-confirm-message">
      {{ message }}
    </p>

    <div class="modal-confirm-actions">
      <button
        class="btn btn-secondary"
        @click="cancel"
      >
        {{ cancelLabel }}
      </button>

      <button
        class="btn btn-icon-text btn-danger"
        @click="confirm"
      >
        <span class="icon-trash"></span>
        {{ confirmLabel }}
      </button>
    </div>

  </div>
</template>

<script>
import { getCurrentInstance, onMounted, onBeforeUnmount } from "vue";
import ModalManager from "@/components/modal/ModalManager";

export default {
  name: "ModalConfirm",

  props: {
    message: {
      type: String,
      required: true
    },
    confirmLabel: {
      type: String,
      default: "Confirm"
    },
    cancelLabel: {
      type: String,
      default: "Cancel"
    }
  },

  setup() {
    const instance = getCurrentInstance();

    onMounted(() => {
      ModalManager.setChildInstance(instance);
    });

    onBeforeUnmount(() => {
      ModalManager.clearChildInstance(instance);
    });
  },

  methods: {
    confirm() {
      this.$emit("close", true);
    },
    cancel() {
      this.$emit("close", false);
    }
  }
};
</script>
